import React from "react";
import { motion } from "framer-motion";
import Phone from "../media/phone5.svg"
import { Helmet } from "react-helmet-async";
import "./kontakt.scss";

export default function Contact() {
  return (
    <section className="contact-section container">
      <>
          <Helmet>
              <title>Pro Moto - kontakt</title>
              <meta
              name="description"
              content="PRO MOTO Zadzwoń, umów się na wizytę i przyjedź do nas!"
              />
              <link rel="canonical" href="https://promotoserwis.pl/kontakt" />
          </Helmet>
      </>
      <div className="contact-section__inner">

        <motion.div
          className="contact-section__header"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="contact-section__title">Zapraszamy do kontaktu</h2>
          <p className="contact-section__subtitle">
            Zadzwoń, umów się na wizytę i przyjedź do nas!
          </p>
        </motion.div>
        <motion.div
          className="contact-section__content"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <div className="contact-section__map">
            <iframe
              title="mapa_dojazdu"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2427.9155650698394!2d16.7026964!3d52.5168671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47043ff782461c41%3A0xa597a3705984f794!2sPro%20Moto%20Aleksander%20Kaczmarek!5e0!3m2!1spl!2spl&hl=pl"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{height:"100vh"}}
            ></iframe>
          </div>

          <div className="contact-section__boxes">

            <div className="contact-box black">
              <h3><img src={Phone} alt="Phone"></img> Serwis</h3>
              <p>
                Masz pytania o naprawę lub przegląd? Zadzwoń,
                od ręki sprawdzimy wolne terminy i podpowiemy,
                co warto zrobić przed sezonem.
              </p>
              <a href="tel:+48535744816" className="contact-phone">
                +48 535 744 816
              </a>
            </div>

            <div className="contact-box orange">
              <h3><img src={Phone} alt="Phone"></img> Sprzedaż</h3>
              <p>
                Wpadł Ci w oko któryś z naszych motocykli? Chwyć
                za telefon – opowiemy o szczegółach, wyślemy
                ekstra zdjęcia i umówimy jazdę próbną.
              </p>
              <a href="tel:+48535744816" className="contact-phone">
                +48 535 744 816
              </a>
            </div>

          </div>
        </motion.div>

      </div>
    </section>
  );
}
